/* eslint no-unused-vars:off */
import React from 'react';
import { render } from 'react-dom';
import configureStore from './configureStore';
import Root from './components/Root';
import CommonStyles from '../styles/common/common.scss';
import EnglishStyles from '../styles/english/main.scss';
import ArabicStyles from '../styles/arabic/main-ar.scss';

const store = configureStore();

render(
  <Root store={store} />,
  document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./js/index.js